import { render, staticRenderFns } from "./OrderSalaryHistoryDetailDialog.vue?vue&type=template&id=21c379bc&scoped=true"
import script from "./OrderSalaryHistoryDetailDialog.vue?vue&type=script&lang=js"
export * from "./OrderSalaryHistoryDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderSalaryHistoryDetailDialog.vue?vue&type=style&index=0&id=21c379bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c379bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c379bc')) {
      api.createRecord('21c379bc', component.options)
    } else {
      api.reload('21c379bc', component.options)
    }
    module.hot.accept("./OrderSalaryHistoryDetailDialog.vue?vue&type=template&id=21c379bc&scoped=true", function () {
      api.rerender('21c379bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/OrderSalaryHistoryDetailDialog.vue"
export default component.exports